<template>
  <div
    id="si-prediction"
    class="app-main-content"
  >
    <prediction-tree-grid
      v-show="view==='list'"
      v-if="!openMultiple"
      ref="predictionTreeGrid"
      :context="context"
      :use-order-center-mode="useOrderCenterMode"
      :order-center-branch="useOrderCenterBranch"
      :approve-cooperation-business="approveCooperationBusiness"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @copy="copyHandle"
      @delete="deleteHandle"
      @batchDelete="batchDeleteHandler"
      @regularBusiness="regularBusinessHandle"
    />
    <prediction-workspace
      v-show="view==='detail'"
      ref="predictionWorkspace"
      :open-multiple="openMultiple"
      :parent-context="context"
      :use-order-center-mode="useOrderCenterMode"
      :approve-cooperation-business="approveCooperationBusiness"
      @copy="copyHandle"
      @add="addHandle"
      @back="backToList"
      @delete="deleteHandle"
      @regularBusiness="regularBusinessHandle"
    />
    <!--业务复制选择复制哪些信息-->
    <job-copy-window
      v-show="copyDialog.visible"
      ref="jobCopyWindow"
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      @confirmCallBack="confirmCallBackHandler"
    />

    <job-no-rule-selector
      v-show="jobNoRule.visible"
      ref="jobCopyWindow"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />

    <sea-im-container-type-dialog
      v-show="jobNewDialog.visible"
      ref="jobNewWindow"
      :visible.sync="jobNewDialog.visible"
      :rules="jobNewDialog.rules || []"
      :show-rule="jobNewDialog.showRule"
      @selectedBack="addHandlerSelect"
    />
    <!--审核弹窗-->
    <op-verify-frame-confirm-dialog
      :visible="opVerifyFrameConfirmDialog.visible"
      :job-model="opVerifyFrameConfirmDialog.job"
      :submit-call-back="opVerifyFrameConfirmDialog.callBack"
      :job-list="opVerifyFrameConfirmDialog.jobList"
      @closePageHandler="closePageHandler"
    />
    <!--预报审批审核弹窗-->
    <forecast-verify-confirm-dialog
      :visible="forecastVerifyConfirmDialog.visible"
      :job-model="forecastVerifyConfirmDialog.job"
      :submit-call-back="forecastVerifyConfirmDialog.callBack"
      @closePageHandler="forecastVerifyConfirmDialog.visible=false"
    />
  </div>
</template>

<script>
import { PredictionWorkspaceContext } from './components/Prediction/predictionWorkspaceContext'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import predictionTreeGrid from './components/Prediction/predictionTreeGrid'
import predictionWorkspace from './components/Prediction/predictionWorkspace'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import {
  doCopyJobOfPrediction,
  findSeaImportJobByNo,
  deleteJobOfPrediction,
  regularBusiness,
  batchDeleteJobOfPredictionHandler, findSeaImportPerNoJob, advancedQuery
} from '@/api/SeaImport/seaImportJob'
import { queryJobNoRule } from '@/api/seaExport/seaExportJob'
import seaImContainerTypeDialog from '@/components/Cargo/Job/seaImContainerTypeDialog'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getConfigBoolValue, sleep } from '@/utils/commonUtil'
import opVerifyFrameConfirmDialog from '@/views/cargo/v0/SeaImport/components/Prediction/opVerifyFrameConfirmDialog'
import forecastVerifyConfirmDialog from '@/views/cargo/v0/SeaImport/components/Prediction/forecastVerifyConfirmDialog'
import { approvedJob, updateJobs } from '@/api/booking/job'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import lodash from 'lodash'
import { cacheName, cache } from '@/utils/cacheManager'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'

export default {
  name: 'SiPrediction',
  components: { predictionTreeGrid, predictionWorkspace, jobCopyWindow, jobNoRuleSelector, seaImContainerTypeDialog, opVerifyFrameConfirmDialog, forecastVerifyConfirmDialog },
  data() {
    return {
      context: PredictionWorkspaceContext.getInstance(),
      view: 'list',
      openMultiple: Boolean(this.$route.query.openNew && this.$route.query.key), // （组件）打开了多个
      forecastApproval: false, // 是否用预报审批流程
      copyDialog: {
        visible: false,
        job: {}
      },
      jobNoRule: {
        visible: false,
        rules: ''
      },
      jobNewDialog: {
        visible: false,
        rules: '',
        showRule: false
      },
      loading: false,
      opVerifyFrameConfirmDialog: { // 审核通过弹窗
        visible: false,
        callBack: null,
        job: null,
        isInner: false,
        jobKeys: null,
        jobList: null,
        approvedWithSlaves: false // 是否将小票同步转正式业务
      },
      forecastVerifyConfirmDialog: { // 预报审批审核通过弹窗
        visible: false,
        callBack: null,
        job: null
      }
    }
  },
  computed: {
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    useOrderCenterBranch() { // 是否开启接单分公司
      return cache.config ? Number(cache.config.get('orderCenterBranch')) === 1 : false
    },
    approveCooperationBusiness() { // 是否协作分公司需审核接单分公司的协作业务
      return cache.config ? Number(cache.config.get('approveCooperationBusiness')) === 1 : false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await sleep(1000)
        this.forecastApproval = await getConfigBoolValue('ForecastApprovalSI')
      }
    }
  },
  async mounted() {
    if (this.openMultiple) {
      this.view = 'detail'
      let rowData = this.$route.params.rowData
      if (!rowData || rowData.length === 0) {
        const loading = getLoading4Cxt(this)
        try {
          const res = await findSeaImportJobByNo({ jobNo: this.$route.query.key, branchId: this.$store.getters.currentOfficeId })
          if (res.data.list.length === 0) {
            this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
            return
          }
          rowData = res.data.list
        } catch (err) {
          this.$message.error(this.$t('Message.JumpFailed'))
          throw err
        } finally {
          loading.close()
        }
      }
      rowData = this.getNewDetailData(rowData)
      const selectedRow = rowData.find(p => p.jobNo === this.$route.query.key)
      if (selectedRow) {
        let action = 'look'
        if (this.$route.params.action) {
          action = this.$route.params.action
          delete this.$route.params.action
        }
        if (this.$route.params.activeTabName) {
          this.$refs.predictionWorkspace.activeTabName = this.$route.params.activeTabName
          delete this.$route.params.activeTabName
        }
        this.$refs.predictionWorkspace.onShow(action, rowData, selectedRow)
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  activated() {
    if (this.$route.query.jobNo) {
      this.toDetailSop(this, this.$route.query.jobNo)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    } else if (this.$route.params.jobNos) {
      const filter = {
        conditions: [
          new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json()
        ]
      }
      JumpUtil.jumpToTab(advancedQuery, filter, this.$route.params, this, 'predictionWorkspace')
    }
  },
  methods: {
    // 查询job后跳转详情
    toDetail(vm, jobNo) {
      const params = {}
      params.branchId = vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      findSeaImportJobByNo(params).then(res => {
        const rowData = this.getNewDetailData(res.data.list)
        if (rowData) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.predictionWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.predictionWorkspace.onShow('look', rowData, rowData[0])
          }
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    // 查看
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    // 编辑
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    // 新增
    async addHandle() {
      if (JobUtils.checkHQ()) { return }
      await this.context.prepareData()
      this.jobNewDialog.showRule = String(this.context.config.get('UseNewJobNoRule')) === '1'
      queryJobNoRule(SystemConstants.SI.code).then(res => {
        const rules = res.data
        if (rules && rules.length > 1) {
          this.jobNewDialog.rules = rules
        }
        this.jobNewDialog.visible = true
      })
    },
    // 新增job 选择类型完成以后得事件
    async addHandlerSelect(data) {
      const job = new SeaImportJob().fillDefaultValue().getData()
      job.jobNoRule = data['jobNoRule']
      job.containerLoadType = data.cargoType
      job.masterFlag = job.containerLoadType === 'CON'
      job.lob = 'SI'
      this.detailHandle('add', job)
    },
    closePageHandler() {
      this.opVerifyFrameConfirmDialog.visible = false
    },
    // 返回列表
    backToList(isRefresh) {
      if (this.openMultiple) {
        this.$router.push({ name: 'SiPrediction', params: {}})
        return
      }
      this.view = 'list'
      if (isRefresh) {
        this.$refs.predictionTreeGrid.toQuery()
      }
    },
    // 复制
    copyHandle(row) {
      // 以后按本次选择复制，不弹出此框
      if (!row) return
      if (JobUtils.checkHQ()) { return }
      this.copyDialog.job = row
      const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob) // 是否显示复制选项弹框【勾选是true不显示】
      if (isShowView !== true) {
        this.copyDialog.visible = true
      } else {
        this.confirmCallBackHandler()
      }
    },
    async confirmCallBackHandler() {
      await this.context.prepareData()
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.loading = getLoading()
        queryJobNoRule(SystemConstants.SI.code).then(res => {
          this.loading.close()
          this.ruleResultHandler(res)
        })
      } else {
        this.doCopyJob()
      }
    },
    ruleResultHandler(event) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.visible = true
        this.jobNoRule.rules = rules
      } else if (rules && rules.length > 0) {
        const rule = rules[0]
        this.doCopyJob(rule)
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doCopyJob(jobNoRule) {
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      item.source = 'prediction'
      const lob = this.copyDialog.job.lob
      item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
      item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
      item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
      const notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      this.loading = getLoading()
      doCopyJobOfPrediction(item).then(async res => {
        this.loading.close()
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        await this.context.prepareData()
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'SiPrediction')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect)
        this.detailHandle('copy', newJob)
      })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.predictionWorkspace.rowData
      } else {
        // rowData = this.$refs.predictionTreeGrid.gridOptions.api.getModel().rowsToDisplay.map(node => node.data)
        rowData = []
        this.$refs.predictionTreeGrid.gridOptions.api.forEachNodeAfterFilterAndSort(node => {
          if (node.data) {
            rowData.push(node.data)
          }
        })
        rowData = this.getNewDetailData(rowData)
        this.view = 'detail'
      }
      if (row.uuid) {
        row = rowData.find(p => p.uuid === row.uuid)
      } else {
        new SeaImportJob(row).fillDefaultValue() // 数据补充完整
        row.version = 0 // 版本号置为0，重新加载job
        row = { ...row } // 需重新构造对象，以便新增加的属性可以被vue监听到
      }
      this.$refs.predictionWorkspace.onShow(type, rowData, row)
    },
    // 删除
    deleteHandle(data) {
      const job = data.job // 删除的Job
      const isInner = data.isInner // 详情页删除:true/列表页删除:false
      if (!job) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (!job.uuid) return
      if (job.jobState > -1) {
        this.$message.warning(this.$t('Message.PromissoryNoteIsAFormalBusiness'))
        return
      }
      let toolTips = ''
      let hasSlave = false // 是否有小票
      if (job.masterFlag) {
        if (isInner) {
          if (job.lclSlaves && job.lclSlaves.length > 0) {
            hasSlave = true
            toolTips = this.$t('queryJob.DoToDeleteTheTicket')
          } else {
            toolTips = this.$t('queryJob.AreWantToDeleteBusiness')
          }
        } else {
          const rowData = this.$refs.predictionTreeGrid.rowData
          // 是否有小票
          if (rowData && rowData.length > 0) {
            for (const item of rowData) {
              if (item.parentUuid && job.uuid && item.parentUuid === job.uuid) {
                hasSlave = true
                break
              }
            }
          }
          if (hasSlave) {
            toolTips = '是否要删除小票?'
          } else {
            toolTips = this.$t('queryJob.AreToDeleteTheBusiness')
          }
        }
      } else {
        if (isInner) {
          toolTips = this.$t('queryJob.AreWantToDeleteBusiness')
        } else {
          toolTips = this.$t('queryJob.AreToDeleteTheBusiness')
        }
      }
      this.$confirm(toolTips, this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        deleteJobOfPrediction(job.uuid).then(res => {
          this.loading.close()
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.refreshGrid(job, isInner)
        }).finally((e) => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    batchDeleteHandler(data) {
      const jobList = data.jobList // 删除的Job
      if (!jobList || jobList.length === 0) return
      const index = jobList.findIndex(p => p.jobState > -1)
      if (index > -1) {
        this.$message.warning(this.$t('Message.PromissoryNoteIsAFormalBusiness'))
        return
      }
      this.$confirm(this.$t('queryJob.AreToDeleteTheBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const list = []
        for (const job of jobList) {
          if (this.forecastApproval) {
            if (job.preverifyState === 3 || job.preverifyState === 6 || job.preverifyState === 4) {
              list.push(job.uuid)
            }
          } else {
            list.push(job.uuid)
          }
        }
        if (this.forecastApproval) {
          if (list.length === 0) {
            this.$message.warning(this.$t('Message.OnlyRejectedBusinessesCanDelete'))
            return
          } else if (list.length < jobList.length) {
            this.$message.warning(this.$t('Message.OnlyRejectedBusinessesCanDeleteIgnoreOther'))
          }
        }
        this.$refs.predictionTreeGrid.clearSelect()
        batchDeleteJobOfPredictionHandler(list).then(res => {
          this.loading.close()
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          for (const job of jobList) {
            this.refreshGrid(job, false)
          }
        }).finally((e) => {
          this.loading.close()
        })
      })
    },
    // 转正式业务
    regularBusinessHandle(data) {
      if (!data) return
      if (this.forecastApproval) {
        if (data.jobs && data.jobs.length > 0 && !data.isInner) {
          this.forecastBatchConvertRealJobHandler(data.jobs)
          return
        }
        if (data.job && data.isInner) {
          this.forecastConvertRealJobHandler(data.job)
          return
        }
      }
      const job = (data.jobs && data.jobs.length > 0) ? data.jobs[0] : data.job // 删除的Job
      const jobs = data.jobs // 列表中批量转正式业务
      const isInner = data.isInner // 详情页删除:true/列表页删除:false
      if (!job && jobs && jobs.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      if (job && job.jobState > -1) {
        this.$message.warning(this.$t('Message.PromissoryNoteIsAFormalBusiness'))
        return
      }
      // 是否被委托业务
      // 若是批量转正式业务，则判断是否都是被委托业务
      let num = 0
      const jobKeys = []
      if (jobs && jobs.length > 0) {
        for (const item of jobs) {
          if (item.jobState > -1) {
            this.$message.warning(this.$t('Message.PromissoryNoteIsAFormalBusiness') + ' ' + item.jobNo)
            return
          }
          num += item.trustFromJob ? 1 : 0
          if (job.uuid === item.uuid) {
            continue
          }
          jobKeys.push(item.uuid)
        }
        // 判断选择的被委托业务数量是否大于0,且不等于选择的数量
        if (num > 0 && jobs.length > num) {
          this.$message.warning(this.$t('Message.CannotBeConvertedToFormalBusinessInBatch'))
          return
        }
      }
      this.opVerifyFrameConfirmDialog.approvedWithSlaves = false
      this.opVerifyFrameConfirmDialog.jobKeys = num > 0 ? jobKeys : null
      this.opVerifyFrameConfirmDialog.jobList = jobs
      if (job && job.trustFromJob) {
        // 如果是主票，且不是批量转正式
        if (job.masterFlag && num === 0) {
          this.$confirm(this.$t('Message.whetherToTransferSmallTicketToFormalBusinessAtTheSameTime'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('Message.transferSmallTicketToFormalJobAtTheSameTime'),
            cancelButtonText: this.$t('Message.onlyTheMasterTicketIsTransferredToFormalJob'),
            type: 'warning'
          }).then(() => {
            this.opVerifyFrameConfirmDialog.approvedWithSlaves = true
            this.approved(job, isInner)
          }).catch(() => {
            this.opVerifyFrameConfirmDialog.approvedWithSlaves = false
            this.approved(job, isInner)
          })
        } else {
          this.approved(job, isInner)
        }
      } else {
        this.regularBusiness(job, jobs, isInner)
      }
    },
    // 预报审批批量转正式业务
    forecastBatchConvertRealJobHandler(jobs) {
      const keys = []
      for (const row of jobs) {
        if (row.preverifyState === 0 || row.preverifyState === 1) {
          keys.push(row.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.success(this.$t('Message.SuccessfullyConvertRealXBusinessOtherIgnore', { num: 0 }))
        return
      }
      const loading = getLoading4Cxt(this)
      regularBusiness(keys).then(res => {
        this.refreshGrid2(keys, false)
        if (keys.length === jobs.length) {
          this.$message.success(this.$t('Message.SuccessfullyConvertRealXBusiness', { num: keys.length }))
        } else {
          this.$message.success(this.$t('Message.SuccessfullyConvertRealXBusinessOtherIgnore', { num: keys.length }))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 预报审批转正式业务
    forecastConvertRealJobHandler(currentRow) {
      const jobs = [{ ...currentRow }]
      const lclSlaves = currentRow.lclSlaves
      if (lclSlaves && lclSlaves.length > 0) {
        for (const item of lclSlaves) {
          if (item.uuid && item.version) {
            jobs.push({ ...item })
          }
        }
      }
      for (const job of jobs) {
        for (const key in job) {
          if (typeof job[key] === 'object') {
            delete job[key]
          }
        }
      }
      this.forecastVerifyConfirmDialog.job = currentRow
      this.forecastVerifyConfirmDialog.callBack = form => {
        let refreshChangeBranch = false
        for (const job of jobs) {
          for (const key in job) {
            if (typeof job[key] === 'object') {
              delete job[key]
            }
          }
          if (!refreshChangeBranch && form.opOffice !== job.opOffice) {
            refreshChangeBranch = true
          }
          Object.assign(job, form, { preverifyState: 2, jobState: 0, preverifier: this.$store.getters.userId, preverifyDate: new Date() })
        }
        const loading = getLoading4Cxt(this)
        updateJobs(jobs, { calculateEstimate: true, refreshChangeBranch }).then(res => {
          this.refreshGrid2(Array.from(jobs, p => p.uuid), true)
          this.$message.success(this.$t('Message.OperationSuccessfully'))
        }).finally(() => {
          loading.close()
        })
      }
      this.forecastVerifyConfirmDialog.visible = true
    },
    // 转正式业务-单票
    approved(job, isInner) {
      this.opVerifyFrameConfirmDialog.job = job
      this.opVerifyFrameConfirmDialog.isInner = isInner
      this.opVerifyFrameConfirmDialog.callBack = this.opVerifyFrameConfirmCallBack
      this.opVerifyFrameConfirmDialog.visible = true
    },
    opVerifyFrameConfirmCallBack(form) {
      if (form) {
        if (this.opVerifyFrameConfirmDialog.isInner) {
          form.uuid = this.opVerifyFrameConfirmDialog.job.uuid
          form.version = this.opVerifyFrameConfirmDialog.job.version
        } else {
          form.uuid = this.opVerifyFrameConfirmDialog.job.jobUuid
          form.version = this.opVerifyFrameConfirmDialog.job.jobVersion
        }
        if (this.opVerifyFrameConfirmDialog.jobKeys && this.opVerifyFrameConfirmDialog.jobKeys.length > 0) {
          form.jobKeys = this.opVerifyFrameConfirmDialog.jobKeys
        }
        form.approvedWithSlaves = this.opVerifyFrameConfirmDialog.approvedWithSlaves
        this.loading = getLoading()
        approvedJob(form).then(res => {
          this.loading.close()
          this.$message.success('审核成功')
          const job = this.opVerifyFrameConfirmDialog.job
          if (form.jobKeys) { // 列表多选
            form.jobKeys.push(form.uuid)
            this.refreshGrid2(form.jobKeys, this.opVerifyFrameConfirmDialog.isInner)
          } else if (form.approvedWithSlaves) { // 详情里主票带小票
            const lclSlaves = job.lclSlaves
            const keys = []
            keys.push(job.uuid)
            if (lclSlaves && lclSlaves.length > 0) {
              for (const item of lclSlaves) {
                if (item.uuid && item.version) {
                  keys.push(item.uuid)
                }
              }
            }
            this.refreshGrid2(keys, this.opVerifyFrameConfirmDialog.isInner)
          } else {
            // 如果是主票单转，且有小票，则不移除主票
            if (job.lclSlaves && job.lclSlaves.length > 0) {
              const rowData = this.opVerifyFrameConfirmDialog.isInner ? this.$refs.predictionWorkspace.rowData : this.$refs.predictionTreeGrid.rowData
              for (let i = 0; i < rowData.length; i++) {
                const row = rowData[i]
                if (row.uuid === job.uuid) {
                  row.jobState = 0
                }
              }
            } else {
              this.refreshGrid(this.opVerifyFrameConfirmDialog.job, this.opVerifyFrameConfirmDialog.isInner)
            }
          }
        }).finally(res => {
          this.loading.close()
        })
      }
    },
    // 转正式业务-批量
    regularBusiness(job, jobs, isInner) {
      const keys = []
      if (job || jobs) {
        if (isInner) { // 详情
          if (job.uuid && job.version) {
            keys.push(job.uuid)
          }
          const lclSlaves = job.lclSlaves
          if (lclSlaves && lclSlaves.length > 0) {
            for (const item of lclSlaves) {
              if (item.uuid && item.version) {
                keys.push(item.uuid)
              }
            }
          }
        } else {
          if (jobs && jobs.length > 0) {
            const tIndex = jobs.findIndex(p => !p.trustFromJob)
            const tIndex2 = jobs.findIndex(p => p.trustFromJob)
            if (tIndex > -1 && tIndex2 > -1) {
              this.$message.warning(this.$t('Message.BusinessCannotBeOperatedTogether'))
              return
            }
            for (const item of jobs) {
              if (item.uuid) {
                keys.push(item.uuid)
              }
            }
          } else if (job) {
            keys.push(job.uuid)
          }
        }
      }
      if (keys.length > 0) {
        this.$confirm(this.$t('queryJob.AreToConvertTheItem'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          regularBusiness(keys).then(res => {
            this.loading.close()
            this.$message.success(this.$t('queryJob.ConversionSucceeded'))
            this.refreshGrid2(keys, isInner)
          }).finally(res => {
            this.loading.close()
          })
        }).catch(() => {
        })
      }
    },
    // 刷新表格数据 详情/列表
    refreshGrid(job, isInner) {
      let rowData = []
      if (isInner) {
        rowData = this.$refs.predictionWorkspace.rowData
      } else {
        rowData = this.$refs.predictionTreeGrid.rowData
      }
      for (let i = 0; i < rowData.length; i++) {
        const row = rowData[i]
        if (row.uuid === job.uuid) {
          rowData.splice(i, 1)
        }
      }
      for (let i = 0; i < rowData.length; i++) {
        const row = rowData[i]
        if (row.parentUuid && job.uuid && row.parentUuid === job.uuid) {
          rowData.splice(i, 1)
        }
      }
      if (isInner) {
        this.$refs.predictionWorkspace.rowData = rowData
        this.$refs.predictionWorkspace.gridApi.refreshCells({ force: true })
        this.$refs.predictionWorkspace.gridApi.redrawRows()
      } else {
        this.$refs.predictionTreeGrid.rowData = rowData
        this.$refs.predictionTreeGrid.gridApi.refreshCells({ force: true })
        this.$refs.predictionTreeGrid.gridApi.redrawRows()
      }
    },
    // 刷新表格数据 详情/列表
    refreshGrid2(keys, isInner) {
      let rowData = []
      if (isInner) {
        rowData = this.$refs.predictionWorkspace.rowData
      } else {
        rowData = this.$refs.predictionTreeGrid.rowData
      }
      for (const uuid of keys) {
        const index = rowData.findIndex(p => p.uuid === uuid)
        if (index > -1) {
          rowData.splice(index, 1)
        }
      }
      if (isInner) {
        this.$refs.predictionWorkspace.rowData = rowData
        this.$refs.predictionWorkspace.gridApi.refreshCells({ force: true })
        this.$refs.predictionWorkspace.gridApi.redrawRows()
      } else {
        this.$refs.predictionTreeGrid.rowData = rowData
        this.$refs.predictionTreeGrid.selectedDataList = []
        this.$refs.predictionTreeGrid.gridApi.refreshCells({ force: true })
        this.$refs.predictionTreeGrid.gridApi.redrawRows()
      }
    },
    getNewDetailData(rowData) {
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new SeaImportJob(item).fillDefaultValue() // 数据补充完整
        item.version = 0 // 版本号置为0，重新加载job
      }
      return rowData
    },
    // 查询job后跳转详情
    toDetailSop(vm, jobNo) {
      const params = {}
      params.branchId = vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      findSeaImportPerNoJob(params).then(res => {
        const rowData = this.getNewDetailData(res.data.list)
        if (rowData && rowData.length !== 0) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.predictionWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.predictionWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.predictionWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    }
  }
}
</script>

<style lang="scss">

#app #si-prediction {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  span {
    font-size: 12px;
  }
  span.el-dialog__title {
    font-size: 18px;
  }
  .el-radio {
    margin-right: 10px;
  }
}
</style>
